import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

const globalTranslationDebugMode: boolean = Boolean(window.FCONST.FS_FRONTEND_TRANSLATION_DEBUG_MODE);

const language: string = window.FCONST.BABEL_DEFAULT_LOCALE || 'en';
let translation: Record<string, any>;
try {
    translation = require(`./translations/${language}.json`);
} catch (e) {
    console.warn(`Translation for "${language}" not found. Falling back to "en".`);
    translation = require('./translations/en.json');
}

i18n
    .use(initReactI18next)
    .init({
        resources: {
            [language]: {
                translation,
            },
        },
        lng: language,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

const originalT = i18n.t.bind(i18n);

i18n.t = ((key: string, options: Record<string, any> = {}): string => {
    const translation = originalT(key, options);
    const isMissing = translation === key;

    if (isMissing) {
        console.warn(`Missing translation for key: "${key}"`);
    }

    if (options.debug || globalTranslationDebugMode) {
        return `${translation} [${key}]`;
    }
    return translation as string;
}) as typeof i18n.t;

export default i18n;
